const SKIPPED_PROTOCOLS = new Set(['mailto:', 'tel:', 'sms:', 'javascript:']);

function getEditorPreviewNavigation(rawHref, currentHref) {
    const href = String(rawHref || '').trim();
    if (!href) return null;

    let currentUrl;
    let targetUrl;

    try {
        currentUrl = new URL(currentHref);
        targetUrl = new URL(href, currentUrl);
    } catch {
        return null;
    }

    if (
        SKIPPED_PROTOCOLS.has(targetUrl.protocol) ||
        !['http:', 'https:'].includes(targetUrl.protocol) ||
        targetUrl.origin !== currentUrl.origin
    ) {
        return null;
    }

    // An internal site link may have its own query string. Retain it while
    // carrying editor state (most importantly the edit token) to the new page.
    currentUrl.searchParams.forEach((value, key) => {
        if (!targetUrl.searchParams.has(key)) {
            targetUrl.searchParams.append(key, value);
        }
    });

    const hrefForRouter = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
    const isSameDocument =
        targetUrl.pathname === currentUrl.pathname &&
        targetUrl.search === currentUrl.search;

    return {
        href: hrefForRouter,
        hash: targetUrl.hash,
        isSameDocument,
    };
}

function scrollPreviewToHash(previewDocument, hash) {
    if (!previewDocument || !hash) return false;

    let targetId;
    try {
        targetId = decodeURIComponent(hash.replace(/^#/, ''));
    } catch {
        targetId = hash.replace(/^#/, '');
    }

    if (!targetId) return false;

    const target =
        previewDocument.getElementById(targetId) ||
        Array.from(previewDocument.getElementsByName(targetId)).find(
            (node) => typeof node.scrollIntoView === 'function'
        );

    if (!target || typeof target.scrollIntoView !== 'function') return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
}

module.exports = {
    getEditorPreviewNavigation,
    scrollPreviewToHash,
};
